import CreateStatContainer from "../containers/CreateStatContainer";

const CreateStatPage = () => {
  return (
    <CreateStatContainer />
  );
};

export default CreateStatPage;
